import React from 'react';
import { useLogoutEmulatedUser } from '~/src/entities/user';
import cookies from '~/src/utils/cookies';

export const RemoteAccessBanner = () => {
  const adminTokensExist = cookies.adminTokensExist();
  const { mutate } = useLogoutEmulatedUser();

  if (!adminTokensExist) return null;

  return (
    <h2>
      You are currently accessing a user&apos;s account.{' '}
      <a href="#" onClick={(e) => (e.preventDefault(), mutate())}>
        Stop Remote Access
      </a>
    </h2>
  );
};
